import { consoleLogStyle, createKey, getSpm, getValidPath, isMac } from './utils';
import type { JimoTrackerSdkData } from './type';

/**
 * 跳转网址添加_jt_preSpm
 */
const handleArgs = (router: any, args: any) => {
  if (router?._tracker?._options?.enableLog) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'handleArgs', args);
  }
  const tracker = router._tracker;

  if (router?._tracker?._options?.enableLog) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'setUrlSpmParams');
  }

  try {
    // try放里面，如果出错，外面可正常执行
    if (!args[2]) {
      return args;
    }
    const isFullUrl = args[2].startsWith('http'); // 是否完整地址
    const urlObj = new URL(isFullUrl ? args[2] : location.origin + args[2]);

    /* const searchParams = urlObj.searchParams;
    searchParams.delete('_jt_preSpm');
    searchParams.append(
      '_jt_preSpm',
      encodeURIComponent(
        `${tracker._mainObj.project_desc}.${tracker.getSpmPathName()}.${
          tracker.preEventData.event_type === 'click' && tracker.preEventData.block_desc
            ? tracker.preEventData.block_desc
            : '0'
        }.${
          tracker.preEventData.event_type === 'click' && tracker.preEventData.button_desc
            ? tracker.preEventData.button_desc
            : '0'
        }.${new Date().getTime()}`?.replace(new RegExp(/\//gi), '___')
      )
    ); */
    args[2] = (isFullUrl ? location.origin : '') + urlObj.pathname + urlObj.search + urlObj.hash;
  } catch (error) {
    console.log('handleArgs error: ', error);
  }

  return args;
};

/**
 * 路由变化时更改page_desc与page_refer
 */
const handleHistoryChange = (router: any, preSpm = '', source = '') => {
  try {
    if (router?._tracker?._options?.enableLog) {
      console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'handleHistoryChange', source);
    }

    const tracker = router._tracker;
    tracker._domSpmCache = new WeakMap(); // dom的spm位置信息缓存，dom移除或切换页面自动清除

    tracker._mainObj.page_desc = getValidPath(location.pathname).slice(tracker._mainObj?.project_desc?.length);
    tracker._mainObj.parameters.router_seq++;
    if (typeof tracker.sessionStore.routerSeq === 'number') {
      tracker.sessionStore.routerSeq++;
    }

    // 设置来源页面 spm 信息
    const preSpmArr = preSpm ? preSpm.split('.') : [];
    if (preSpmArr.length && preSpmArr[0] !== '0') {
      tracker._mainObj.parameters.pre_project_desc = preSpmArr[0];
      tracker._mainObj.parameters.pre_page_desc = preSpmArr[1];
      tracker._mainObj.parameters.pre_block_desc = preSpmArr[2] !== '0' ? preSpmArr[2] : '';
      tracker._mainObj.parameters.pre_button_desc = preSpmArr[3] !== '0' ? preSpmArr[3] : '';
      tracker._mainObj.parameters.pre_button_t = preSpmArr[4];
    } else {
      tracker._mainObj.parameters.pre_project_desc = '';
      tracker._mainObj.parameters.pre_page_desc = '';
      tracker._mainObj.parameters.pre_block_desc = '';
      tracker._mainObj.parameters.pre_button_desc = '';
      tracker._mainObj.parameters.pre_button_t = '';
    }

    // 拼接来源路径;
    const nowRouterStack = router._routerStack.slice(0, router._routerIndex + 1);
    if (nowRouterStack.length >= 2) {
      const referIndex = nowRouterStack.length - 2;
      tracker._mainObj.parameters.page_refer = nowRouterStack[referIndex].path;
    } else {
      tracker._mainObj.parameters.page_refer = undefined;
    }
  } catch {}
};

/**
 * routerStack 初始化
 */
const routerStackInit = (router: any) => {
  if (router?._tracker?._options?.enableLog) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'routerStackInit');
  }

  const ctx = router._tracker;
  const key = createKey();
  router.routerStack.push({
    key,
    path: location.pathname + location.search + location.hash,
    pathname: location.pathname,
  });
  router.routerIndex = 0;

  history.replaceState({ ...history.state, _jt_router_key: key}, '', location.href);

  if (typeof ctx.sessionStore.routerSeq === 'number') {
    ctx._mainObj.parameters.router_seq = ctx.sessionStore.routerSeq;
  } else {
    ctx._mainObj.parameters.router_seq = -1;
    ctx.sessionStore.routerSeq = -1;
  }

  const preSpm = ctx.sessionStore.unloadUrl && ctx.sessionStore.unloadUrl === location.href ? ctx.sessionStore.preSpm : ctx.sessionStore.unloadSpm;
  ctx.sessionStore.preSpm = preSpm;

  handleHistoryChange(router, preSpm, 'routerStackInit');
};

/**
 * 监听前进后退与back forward go
 */
const addEventListenerPopstate = (router: any) => {

  // 兼容 ios 微信页面打开时默认执行 popstate
  window._jt_canPopstate = false;

  if (isMac()) {
    window._jt_canPopstateTimer = setTimeout(() => {
      window._jt_canPopstate = true;
    }, 1000);
  } else {
    window._jt_canPopstate = true;
  }

  window.addEventListener('popstate', function (event) {
    if (router?._tracker?._options?.enableLog) {
      console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'popstate', event.state, location.href, window._jt_canPopstate);
    }

    if (window._jt_canPopstate) {
      let preSpm = '';
      try {
        const popTargetIndex = router._routerStack.findIndex((item: any) => {
          if (item?.key || event.state?._jt_router_key) {
            return item?.key === event.state?._jt_router_key;
          } else {
            return false;
          }
        });

        if (popTargetIndex >= router._routerIndex) {
          router._tracker.sendTracker({
            event_type: 'hot_forward',
            block_desc: '',
            button_desc: 'left_slide',
          } as JimoTrackerSdkData);
          preSpm = getSpm({
            pageDesc: router._tracker._mainObj.page_desc,
            blockDesc: 'browser_toolbar',
            buttonDesc: 'hot_forward',
          });
          router._tracker.sessionStore.preSpm = preSpm;
          handleHistoryChange(router, preSpm, 'popstate:hot_forward');
        } else if (popTargetIndex < router._routerIndex) {
          router._tracker.sendTracker({
            event_type: 'hot_return',
            block_desc: '',
            button_desc: 'right_slide',
          } as JimoTrackerSdkData);
          preSpm = getSpm({
            pageDesc: router._tracker._mainObj.page_desc,
            blockDesc: 'browser_toolbar',
            buttonDesc: 'hot_return',
          });
          router._tracker.sessionStore.preSpm = preSpm;
          handleHistoryChange(router, preSpm, 'popstate:hot_return');
        }
        router._routerIndex = popTargetIndex === -1 ? 0 : popTargetIndex;
      } catch (error) {
        console.log('popstate error:', error);
      }
    }

  });
};

/**
 * 拦截pushState
 */
const interceptPushState = (router: any) => {
  if (router?._tracker?._options?.enableLog) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'interceptPushState');
  }
  try {
    const oldPushState = history.pushState;
    history.pushState = function (...args) {
      // 注意：此处 args react-router 和 vue-router 传入参数不一样，react-router 有 key，vue-router 没有 key，所以统一使用 createKey 代替
      // history.pushState 可能会被第三方多次调用，如果是 vue-router 或 react-router 调用的才会处理
      if (args[2] && (args[0]?.key || args[0]?.current)) {
        if (router?._tracker?._options?.enableLog) {
          console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'pushState', args, 'location.href', location.href);
        }

        const isFullUrl = (args[2] as string).startsWith('http'); // 是否完整地址
        const urlObj = new URL(isFullUrl ? args[2] : location.origin + args[2]);
        const curPath = location.pathname;
        const newPath = urlObj.pathname;

        // 如果目标路径没有发生变化，说明可能是重复执行了 replaceState 或 pushState 操作，不执行相关操作
        // 自跳转的页面除外 之所以使用白名单是因为 vue-router 会执行多次临时 replaceState，且地址参数会变化
        if (curPath !== newPath || router?._tracker?._options?.gotoSelfPagePaths.some((item: string) => curPath.indexOf(item) !== -1)) {
          const key = createKey();
          args[0]._jt_router_key = key;
          router._routerStack.splice(++router._routerIndex);
          router._routerStack.push({
            key,
            path: location.pathname + location.search + location.hash,
            pathname: location.pathname,
          });

          const preSpm = getSpm();
          router._tracker.sessionStore.preSpm = preSpm;

          oldPushState.apply(this, handleArgs(router, args));

          handleHistoryChange(router, preSpm, 'pushState');
        } else {
          oldPushState.apply(this, handleArgs(router, args));
        }
      }
    };
  } catch {}
};

/**
 * 拦截replaceState
 */
const interceptReplaceState = (router: any) => {
  if (router?._tracker?._options?.enableLog) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'interceptReplaceState');
  }
  try {
    const oldReplaceState = history.replaceState;
    history.replaceState = function (...args) {
      // 注意：此处 args react-router 和 vue-router 传入参数不一样，react-router 有 key，vue-router 没有 key，所以统一使用 createKey 代替
      // history.replaceState 可能会被第三方多次调用，如果是 vue-router 或 react-router 调用的才会处理
      if (args[2] && (args[0]?.key || args[0]?.current)) {
        if (router?._tracker?._options?.enableLog) {
          console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'replaceState', args, 'location.href', location.href);
        }

        const isFullUrl = (args[2] as string).startsWith('http'); // 是否完整地址
        const urlObj = new URL(isFullUrl ? args[2] : location.origin + args[2]);
        const curPath = location.pathname;
        const newPath = urlObj.pathname;

        // 如果目标路径没有发生变化，说明可能是重复执行了 replaceState 或 pushState 操作，不执行相关操作
        // 自跳转的页面除外 之所以使用白名单是因为 vue-router 会执行多次临时 replaceState，且地址参数会变化
        if (curPath !== newPath || router?._tracker?._options?.gotoSelfPagePaths.some((item: string) => curPath.indexOf(item) !== -1)) {
          const key = createKey();
          args[0]._jt_router_key = key;
          router._routerStack[router._routerIndex] = {
            key,
            path: location.pathname + location.search + location.hash,
            pathname: location.pathname,
          };

          const preSpm = getSpm();
          router._tracker.sessionStore.preSpm = preSpm;

          oldReplaceState.apply(this, handleArgs(router, args));

          handleHistoryChange(router, preSpm, 'replaceState');
        } else {
          oldReplaceState.apply(this, handleArgs(router, args));
        }
      }
    };
  } catch {}
};

export default class Router {
  private _routerStack: Array<any>; // 路由栈
  private _routerIndex: number; // 路由指针
  private _tracker: any; // tracker对象
  constructor(tracker: any) {
    this._tracker = tracker;
    this._routerStack = [];
    this._routerIndex = 0;
  }

  /**
   * Router初始化
   */
  public init() {
    routerStackInit(this);
    addEventListenerPopstate(this);
    interceptPushState(this);
    interceptReplaceState(this);
  }

  public get routerStack() {
    return this._routerStack;
  }

  public set routerStack(data) {
    this._routerStack = data;
  }

  public get routerIndex() {
    return this._routerIndex;
  }

  public set routerIndex(data) {
    this._routerIndex = data;
  }
}
